import { RootState } from "..";

// Screw properties related
export const getScrewFetchStatus = (state: RootState) =>
  state.ScrewReducer.screwFetchStatus;

export const getScrewProperties = (state: RootState) =>
  state.ScrewReducer.screwProperties;

export const getScrewData = (state: RootState) =>
  state.ScrewReducer.screwData;

// Uploading screw image
export const getScrewUploadStatus = (state: RootState) =>
  state.ScrewReducer.screwUploadStatus;

export const getUploadedScrewData = (state: RootState) =>
  state.ScrewReducer.uploadedScrewData;

// Adding screw to dataset
export const getUploadedScrewStatus = (state: RootState) =>
  state.ScrewReducer.addNewScrewStatus;

export const getActiveScrew = (state: RootState) =>
  state.ScrewReducer.activeScrew;

export const getScrewUpdateStatus = (state: RootState) =>
  state.ScrewReducer.screwUpdateStatus;

export const getScrewFilters = (state: RootState) =>
  state.ScrewReducer.screwFilters;

export const getScrewsAmount = (state: RootState) =>
  state.ScrewReducer.screwsTotalAmount;
